export default {
  fiche: {
    list: {
      title: 'Mes fiches conseil',
      noDataText: 'Aucune fiche ne correspond aux critères de recherche',
      downloadHover: 'Télécharger',
      eyeHover: 'Visualiser',
      headers: {
        libelleDocument: 'Libellé',
        nomDocument: 'Nom du document',
        dateCreation: 'Date de création',
        typeDocument: 'Type de document',
      },
    },
  },
}
